export default "__VITE_ASSET__CJqQexyP__"